import { render, staticRenderFns } from "./ForeignTradeAgent.vue?vue&type=template&id=0ed68f4c&scoped=true"
import script from "./ForeignTradeAgent.vue?vue&type=script&lang=js"
export * from "./ForeignTradeAgent.vue?vue&type=script&lang=js"
import style0 from "./ForeignTradeAgent.vue?vue&type=style&index=0&id=0ed68f4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed68f4c",
  null
  
)

export default component.exports